import React from 'react';
import PropTypes from 'prop-types';

const TopicsItem = ({ url, title, description }) => {
    let params = getURLParams(url);
    if (params){
        var URL = `${url}&iref=kwmbs`;
    } else {
        var URL = `${url}?iref=kwmbs`;
    }
    return (
        <li><a href={URL}>{title}</a></li>
    );
}

TopicsItem.propTypes = {
    topic: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
    })
}

var getURLParams = function(path) {
    if (!path) return false;
 
    var param = path.match(/\?([^?]*)$/);
 
    if (!param || param[1] === '') return false;
 
    var tmpParams = param[1].split('&');
    var keyValue  = [];
    var params    = {};
 
    for (var i = 0, len = tmpParams.length; i < len; i++) {
        keyValue = tmpParams[i].split('=');
        params[keyValue[0]] = keyValue[1];
    }
 
    return params;
};

export default TopicsItem;